import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericPercentageInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { useInputBlurAction } from '../../hooks';
import { useAppStore } from '../../stores';

const DocumentSignedShareInput: InputWithoutSource = ({ input }) => {
    const { actionStore } = useAppStore();

    const { handleFocus, handleBlur, handleKeyDown } = useInputBlurAction(input, () =>
        actionStore.changeDocumentSignedShare(input.worksheetId, input.nodeId)
    );

    return (
        <GenericPercentageInput
            label={input.name}
            input={input}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
        />
    );
};

DocumentSignedShareInput.meta = {
    inputType: InputModel.name
};

export default observer(DocumentSignedShareInput);
